<template>
  <div
    class="exam-mask-info-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="exam-mask-info-title"
    @keydown.esc="close"
  >
    <div
      class="exam-mask-info-modal__backdrop"
      aria-hidden="true"
      @click="close"
    />
    <div class="exam-mask-info-modal__card">
      <h2
        id="exam-mask-info-title"
        class="exam-mask-info-modal__title"
      >
        ATENÇÃO
      </h2>
      <div
        class="exam-mask-info-modal__icon"
        aria-hidden="true"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <circle
            cx="20"
            cy="20"
            r="19"
            stroke="#7f1a54"
            stroke-width="2"
          />
          <text
            x="15"
            y="27"
            font-family="Roboto, sans-serif"
            font-size="24"
            font-weight="600"
            fill="#7f1a54"
          >
            i
          </text>
        </svg>
      </div>
      <p class="exam-mask-info-modal__message">
        O acesso à
        <strong>Máscara de Laudo</strong>
        foi atualizada: ela agora está disponível por versão no bloco
        <strong>"Metodologia / Valor de Referência"</strong>
        , de acordo com a NTO.
      </p>
      <button
        ref="confirmBtn"
        class="btn-primary exam-mask-info-modal__btn"
        @click="close"
      >
        Entendi
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamMaskInfoModal',
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.confirmBtn) {
        this.$refs.confirmBtn.focus()
      }
    })
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.exam-mask-info-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;

  &__backdrop {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.54);
    cursor: pointer;
  }

  &__card {
    position: relative;
    background: #ffffff;
    border-radius: 12px;
    padding: 32px 28px;
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    gap: 16px;
  }

  &__title {
    font-size: 18px;
    font-weight: 700;
    color: #303030;
    margin: 0;
    letter-spacing: 0.5px;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__message {
    font-size: 14px;
    color: #444;
    line-height: 1.6;
    margin: 0;

    strong {
      color: #7f1a54;
    }
  }

  &__btn {
    width: 100%;
    margin-top: 8px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 8px;
  }
}
</style>
